import { createSelector } from 'reselect'

const getOnboardingData = state => state.onboarding
const getAccountData = state => state.myAccount

const onboardingSubjectsSelector = createSelector(
	[getOnboardingData, getAccountData],
	(onboarding, accountData) => {
		let subjectsList
		try {
			subjectsList = onboarding.subjects.map(subjectId => accountData.data.subjects.filter(subjectData => subjectId === subjectData.id)[0].value)
		} catch (err) {
			subjectsList = []
		}
		return {
			subjectsList,
			subjectIds: onboarding.subjects,
			updated: onboarding.subjects !== onboarding.saved_subjects && onboarding.subjects_updated,
		}
	}
)

export default onboardingSubjectsSelector
